import dayjs from "dayjs";
import { amber, green, maroon, orange, red, textGeen, yellowish } from "../assets/colors";

export const tableOffsets = [
	{ name: 5 },
	{ name: 10 },
	{ name: 15 },
	{ name: 20 },
	{ name: 50 },
	{ name: 100 },
];

export const tableOffsets2 = [
	{ name: 10 },
	{ name: 15 },
	{ name: 20 },
	{ name: 50 },
	{ name: 100 },
];

export const tableFilterOption = [
	{ name: "WORKer" },
	{ name: "Gender" },
	{ name: "Contact Number" },
	{ name: "District" },
	{ name: "Chapter" },
	{ name: "Selected District 1" },
	{ name: "Selected Chapter 1" },
	{ name: "Selected District 2" },
	{ name: "Selected Chapter 2" },
	{ name: "Alliance" },
	{ name: "Team Leader" },
	{ name: "Supervisor" },
];

export const reportTableFilterOption = [
	{ name: "WORKer" },
	{ name: "Contact Number" },
	{ name: "Alliance" },
	{ name: "Supervisor" },
	{ name: "Team Leader" },
];

export const leadTableFilterOption = [
	{ name: "Lead Name" },
	{ name: "Lead Contact" },
	{ name: "Phone Name" },
	{ name: "District" },
	{ name: "Chapter" },
];

export const unAssignedLeadTableFilterOption = [
	{ name: "Lead Name" },
	{ name: "Lead Contact" },
	{ name: "Phone Name" },
	{ name: "Gender" },
	{ name: "Age" },
	{ name: "District" },
	{ name: "Chapter" },
];

export const leadsTaskList = [
	{
		taskTitle2: "Introduction of Allama",
		taskName: "introductionOfAllama",
	},
	{
		taskTitle2: "Importance of Dars-e-Quran",
		taskName: "importanceOfDarseQuran",
	},
	{
		taskTitle2: "Quran TPI Course",
		taskName: "QuranTPICourse",
	},
	{
		taskTitle2: "Added to WhatsApp Group",
		taskName: "addedToWhatsApp",
	},
	{
		taskTitle2: "Explained 2026",
		taskName: "explained2026",
	},
];

export const dashboardsList = [
	{ name: "One Time Task" },
	{ name: "Daily Task" },
	{ name: "Weekly Task" },
	{ name: "Monthly Task" },
	{ name: "Members" },
	{ name: "Leads" }
];

export const adminDashboardsList = [
	{ name: "One Time Task" },
	{ name: "Daily Task" },
	{ name: "Weekly Task" },
	{ name: "Monthly Task" },
	{ name: "Members" },
	{ name: "Leads" },
	{ name: "WORKers"},
	{ name: "Poll"}
	// { name: "Chapters"}
];

export const stateHeadDashboardsList = [
	{ name: "Leads" },
	{ name: "WORKers"},
	{ name: "Poll"}
]

export const districtHeadDashboardsList = [
	{ name: "Leads" },
	{ name: "WORKers"},
	{ name: "Poll"}
]

export const weekDropDown = [
	{ name: "Week 1", displayName: "Week 1 / (25Nov - 1Dec)", weekNumber: 1 },
	{ name: "Week 2", displayName: "Week 2 / (2Dec - 8Dec)", weekNumber: 2 },
	{ name: "Week 3", displayName: "Week 3 / (9Dec - 15Dec)", weekNumber: 3 },
	{ name: "Week 4", displayName: "Week 4 / (16Dec - 22Dec)", weekNumber: 4 },
	{ name: "Week 5", displayName: "Week 5 / (23Dec - 29Dec)", weekNumber: 5 },
	{ name: "Week 6", displayName: "Week 6 / (30Dec - 5Jan)", weekNumber: 6 },
	{ name: "Week 7", displayName: "Week 7 / (6Jan - 12Jan)", weekNumber: 7 },
	{ name: "Week 8", displayName: "Week 8 / (13Jan - 19Jan)", weekNumber: 8 },
	{ name: "Week 9", displayName: "Week 9 / (20Jan - 26Jan)", weekNumber: 9 },
	{ name: "Week 10", displayName: "Week 10 / (27Jan - 2Feb)", weekNumber: 10 },
	{ name: "Week 11", displayName: "Week 11 / (3Feb - 9Feb)", weekNumber: 11 },
	{ name: "Week 12", displayName: "Week 12 / (10Feb - 16Feb)", weekNumber: 12 },
	{ name: "Week 13", displayName: "Week 13 / (17Feb - 23Feb)", weekNumber: 13 },
	{ name: "Week 14", displayName: "Week 14 / (24Feb - 1Mar)", weekNumber: 14 },
	{ name: "Week 15", displayName: "Week 15 / (2Mar - 8Mar)", weekNumber: 15 },
	{ name: "Week 16", displayName: "Week 16 / (9Mar - 15Mar)", weekNumber: 16 },
	{ name: "Week 17", displayName: "Week 17 / (16Mar - 22Mar)", weekNumber: 17 },
	{ name: "Week 18", displayName: "Week 18 / (23Mar - 29Mar)", weekNumber: 18 },
	{ name: "Week 19", displayName: "Week 19 / (30Mar - 5Apr)", weekNumber: 19 },
	{ name: "Week 20", displayName: "Week 20 / (6Apr - 12Apr)", weekNumber: 20 },
	{ name: "Week 21", displayName: "Week 21 / (13Apr - 19Apr)", weekNumber: 21 },
	{ name: "Week 22", displayName: "Week 22 / (20Apr - 26Apr)", weekNumber: 22 },
	{ name: "Week 23", displayName: "Week 23 / (27Apr - 3May)", weekNumber: 23 },
	{ name: "Week 24", displayName: "Week 24 / (4May - 10May)", weekNumber: 24 },
];

// export function getCurrentWeek() {
// 	let today = dayjs();
// 	if (today < dayjs("2024-12-02T00:00:00")) {
// 		console.log("Week :::::: ", weekDropDown[0]);
// 		return weekDropDown[0];
// 	} else if (today < dayjs("2024-12-09T00:00:00")) {
// 		return weekDropDown[1];
// 	} else if (today < dayjs("2024-12-16T00:00:00")) {
// 		return weekDropDown[2];
// 	} else if (today < dayjs("2024-12-23T00:00:00")) {
// 		return weekDropDown[3];
// 	} else if (today < dayjs("2024-12-30T00:00:00")) {
// 		return weekDropDown[4];
// 	} else if (today < dayjs("2025-01-06T00:00:00")) {
// 		return weekDropDown[5];
// 	} else if (today < dayjs("2025-01-13T00:00:00")) {
// 		return weekDropDown[6];
// 	} else if (today < dayjs("2025-01-20T00:00:00")) {
// 		return weekDropDown[7];
// 	} else if (today < dayjs("2025-01-27T00:00:00")) {
// 		return weekDropDown[8];
// 	} else if (today < dayjs("2025-02-03T00:00:00")) {
// 		return weekDropDown[9];
// 	} else if (today < dayjs("2025-02-10T00:00:00")) {
// 		return weekDropDown[10];
// 	} else if (today < dayjs("2025-02-17T00:00:00")) {
// 		return weekDropDown[11];
// 	} else if (today < dayjs("2025-02-24T00:00:00")) {
// 		return weekDropDown[12];
// 	} else {
// 		return weekDropDown[13];
// 	}
// }

export function getCurrentWeek() {
	let today = dayjs();
	const weekStartDates = [
		"2024-12-02",
		"2024-12-09",
		"2024-12-16",
		"2024-12-23",
		"2024-12-30",
		"2025-01-06",
		"2025-01-13",
		"2025-01-20",
		"2025-01-27",
		"2025-02-03",
		"2025-02-10",
		"2025-02-17",
		"2025-02-24",
		"2025-03-03",
		"2025-03-10",
		"2025-03-17",
		"2025-03-24",
		"2025-03-31",
		"2025-04-07",
		"2025-04-14",
		"2025-04-21",
		"2025-04-28",
		"2025-05-05",
	];

	for (let i = 0; i < weekStartDates.length; i++) {
		if (today < dayjs(`${weekStartDates[i]}T00:00:00`)) {
			return weekDropDown[i];
		}
	}
	return weekDropDown[weekDropDown.length - 1];
}

export const monthDropDown = [
	{
		name: "Month 1",
		displayName: "Month 1 / (25 Nov - 25 Dec)",
		monthNumber: 1,
	},
	{
		name: "Month 2",
		displayName: "Month 2 / (26 Dec - 25 Jan)",
		monthNumber: 2,
	},
	{
		name: "Month 3",
		displayName: "Month 3 / (26 Jan - 25 Feb)",
		monthNumber: 3,
	},
	{
		name: "Month 4",
		displayName: "Month 4 / (26 Feb - 25 Mar)",
		monthNumber: 4,
	},
	{
		name: "Month 5",
		displayName: "Month 5 / (26 Mar - 25 Apr)",
		monthNumber: 5,
	},
	{
		name: "Month 6",
		displayName: "Month 6 / (26 Apr - 25 May)",
		monthNumber: 6,
	},
];

// export function getCurrentMonth() {
// 	let today = dayjs();
// 	if (today < dayjs("2024-12-26T00:00:00")) {
// 		return monthDropDown[0];
// 	} else if (today < dayjs("2025-01-26T00:00:00")) {
// 		return monthDropDown[1];
// 	} else if (today < dayjs("2025-02-26T00:00:00")) {
// 		return monthDropDown[2];
// 	} else {
// 		return monthDropDown[3];
// 	}
// }

export function getCurrentMonth() {
	let today = dayjs();
	const monthStartDates = [
		"2024-12-26",
		"2025-01-26",
		"2025-02-26",
		"2025-03-26",
		"2025-04-26",
	];
	for (let i = 0; i < monthStartDates.length; i++) {
		if (today < dayjs(`${monthStartDates[i]}T00:00:00`)) {
			return monthDropDown[i];
		}
	}
	return monthDropDown[monthDropDown.length - 1];
}

export const dashboardColumnMapping = {
	contactNumber: "Contact Number",
	name: "Name",
	gender: "Gender",
	district: "District",
	chapter: "Chapter",
	selectedDistrict: "Selected District",
	selectedChapter: "Selected State",
	secondSelectedDistrict: "Second Selected District",
	secondSelectedChapter: "Second Selected State",
	allianceName: "Alliance",
	leaderName: "Leader",
	supervisorName: "Supervisor",
};

export const leadsColumnMapping = {
	name: "Name",
	gender: "Gender",
	age: "Age",
	contactNumber: "Contact Number",
	phoneName: "Phone Name",
	district: "District",
	chapter: "Chapter",
	inchargeContact: "Incharge Contact",
	inchargeName: "Incharge Name",
	leaderName: "Team Leader",
	supervisorName: "Supervisor",
	leadStatus: "Lead Status",
	leadResponse: "Lead Response",
};

export const unAssignedLeadsColumnMapping = {
	name: "Name",
	gender: "Gender",
	age: "Age",
	contactNumber: "Contact Number",
	phoneName: "Phone Name",
	district: "District",
	state: "Chapter",
};

export const reportColumnMapping = {
	contactNumber: "Contact Number",
	name: "WORKer",
	allianceName: "Alliance",
	supervisorName: "Supervisor",
	leaderName: "Team Leader",
	taskDone: "Tasks Done",
	taskPending: "Tasks Pending",
};

export const leadRatingLevels = {
	1: { label: "Anti Allama", color: red },
	2: { label: "Time Waste", color: red },
	3: { label: "Not Interested", color: yellowish },
	4: { label: "Low Response", color: yellowish },
	5: { label: "Interested In Knowledge", color: yellowish },
	6: { label: "Potential WORKer", color: green },
	7: { label: "VIP Contact", color: green },
};

export const genderList = [{ name: "Male" }, { name: "Female" }];

export const age = [
	{ name: 15 },
	{ name: 16 },
	{ name: 17 },
	{ name: 18 },
	{ name: 19 },
	{ name: 20 },
	{ name: 21 },
	{ name: 22 },
	{ name: 23 },
	{ name: 24 },
	{ name: 25 },
	{ name: 26 },
	{ name: 27 },
	{ name: 28 },
	{ name: 29 },
	{ name: 30 },
	{ name: 31 },
	{ name: 32 },
	{ name: 32 },
];

// export const slogansData = [
// 	"हमारा पूज्य - एक परमेश्वर",
// 	"हमारी जाति - मानव परिवार",
// 	"हमारा सपना - अखंड भारत",
// 	"हमारा गौरव - हिंदुस्तान",
// 	"हमारा संकल्प - युग परिवर्तन",
// 	"सतयुग जब शुरू होगा, भारत विश्वगुरु होगा।",
// ];

export const slogansData = [
	"हमारा पूज्य - एक परमेश्वर",
	"हमारी जाति - मानव परिवार",
	"हमारा सपना - अखंड भारत",
	"हमारा गौरव - हिंदुस्तान",
	"हमारा संकल्प - युग परिवर्तन",
	"सतयुग जब शुरू होगा, भारत विश्वगुरु होगा।",
	"",
	"Our Lord - One God",
	"Our Caste - One Human Family",
	"Our Dream - One Earth (Akhand Bharat)",
	"Our Pride - Our Nation (Hindustan)",
	"Our Pledge - New Era (Yug Parivartan)",
	"When the Golden Age occurs (Satyuga)",
	"We shall be the Global Mentor (Vishwaguru)",
];

export const hindiSlogansFP = [
	"हमारा पूज्य",
	"हमारी जाति",
	"हमारा सपना",
	"हमारा गौरव",
	"हमारा संकल्प"
]

export const hindiSlogansSP = [
	"एक परमेश्वर",
	"मानव परिवार",
	"अखंड भारत",
	"हिंदुस्तान",
	"युग परिवर्तन"
]

export const leadStatus = [
	{ id: 1, title: "Not Initiated", value: "notInitiated" },
	{ id: 2, title: "Follow Up", value: "followUp" },
	{ id: 3, title: "Wrong Number", value: "wrongNumber" },
	{ id: 4, title: "Not Reachable", value: "notReachable" },
	{ id: 5, title: "Closed", value: "closed" },
];

export const leadResponse = [
	{ id: 1, title: "VIP Contact", value: "vipContact" },
	{ id: 2, title: "Potential WORKer", value: "potentialWORKer" },
	{ id: 3, title: "Interested in Knowledge", value: "interestedInKnowledge" },
	{ id: 4, title: "Low Response", value: "lowResponse" },
	{ id: 5, title: "Not Interested", value: "notInterested" },
	{ id: 6, title: "Time Waste", value: "timeWaste" },
	{ id: 7, title: "Anti Allama", value: "antiAllama" },
];

export const leadResponseMapping = {
	1: "Anti Allama",
	2: "Time Waste",
	3: "Not Interested",
	4: "Low Response",
	5: "Interested In Knowledge",
	6: "Potential WORKer",
	7: "VIP Contact",
};

export const obligationList = [
	{name: 'State Head'},
	{name: 'District Head'},
	{name: 'WORKer'}
]

export const quizWAppMsgOld = `
https://youtu.be/o_OK-4FXXwM?si=TRYhQNddDRMbGmXn
🌙 Nabi e Rahmat Quiz 2025 🌙
Theme: Depth of Islam

📲 Contact for More Information:
WhatsApp: +91 9368009628

✅ Terms & Conditions:
Diye gaye Quiz App mein uplabdh hain.

🏆 Prizes (30 Winners):
✨ 1st Prize: One Umrah Package / Dubai Tour for 2 persons — Winner & Companion (Companion must be a registered participant too)
📱 2nd Prize: iPhone 15
💻 3rd Prize: Laptop
📖 4th Prize: Pen Digital Quran
🎧 5th Prize: Earbuds for next 25 winners

📅 Last Date to Play: 15th August 2025
📢 Results Announcement: 24th August 2025

📌 Watch this video -https://youtu.be/o_OK-4FXXwM?si=TRYhQNddDRMbGmXn

 & download the app to participate:
▶️ Quiz Android App: [https://play.google.com/store/apps/details?id=co.diy4.einwz]
▶️ Quiz iPhone App: [https://apps.apple.com/us/app/classplus/id1324522260]
🗝️ Org Code: EINWZ

🎥 Nabi e Rahmat Quiz 2025 Playlist: [https://youtube.com/playlist?list=PLTPwffe8uEJvGt4_963elX_GRE-6U_8ZU&si=XU86BTS8MukIjvUV]
🎥 Winners Feedback Video (2023): [https://youtu.be/-0As5Rb86wc?si=PW5aeL6xYiUSCC6L]
🏅 106 Winners of 2023
https://allamasyedabdullahtariq.com/nabi-e-rahmat-quiz-2023`


export const pollPieModes = [
	{name: 'Count'},
	{name: 'Percentage'}
]

export const logoOptions = [
	{name: 'WORK'},
	{name: 'Compassion'}
]

export const pollTypeOptions = [
	{name: 'Poll'},
]

export const ECPollTypeOptions = [
	{name: 'Poll'},
	{name: 'Voting'}
]

export const quizWAppMsg = `🌍💙 Let’s honor the Prophet of Mercy ﷺ by making compassion a global legacy.

✍️ Sign to support Global Compassion Day!

https://chng.it/qfwJGZGQvn`


export const workerTypes = [
  { label: "Nucleus", info: "Members who have completed Orientation Level 2." },
  { label: "Core", info: "Members who have completed Orientation Level 1." },
  { label: "Active", info: "Members who actively participate in both Field work and Activities." },
  { label: "Compassionate", info: "Members who participate in activities only." },
  { label: "Virtually Active", info: "Members who support solely through social media engagement."},
  { label: "Inactive", info: "Members who are currently not involved in any activities or engagement"},
];

export const WORKerTypesList = [
	{value: 'nucleus', label: 'Nucleus', info: "Members who have completed Orientation Level 2.", color: green},
	{value: 'core', label: 'Core', info: "Members who have completed Orientation Level 1.", color: textGeen},
	{value: 'active', label: 'Active', info: "Members who actively participate in both Field work and Activities.", color: amber},
	{value: 'compassionate', label: 'Compassionate', info: "Members who participate in activities only.", color: orange},
	{value: 'virtuallyActive', label: 'Virtually Active', info: "Members who support solely through social media engagement.", color: maroon},
	{value: 'inActive', label: 'Inactive', info: "Members who are currently not involved in any activities or engagement", color: red},
]

export const  countryCodes = [
  { name: "+93" },
  { name: "+355" },
  { name: "+213" },
  { name: "+1-684" },
  { name: "+376" },
  { name: "+244" },
  { name: "+1-264" },
  { name: "+1-268" },
  { name: "+54" },
  { name: "+374" },
  { name: "+297" },
  { name: "+61" },
  { name: "+43" },
  { name: "+994" },

  { name: "+1-242" },
  { name: "+973" },
  { name: "+880" },
  { name: "+1-246" },
  { name: "+375" },
  { name: "+32" },
  { name: "+501" },
  { name: "+229" },
  { name: "+1-441" },
  { name: "+975" },
  { name: "+591" },
  { name: "+387" },
  { name: "+267" },
  { name: "+55" },
  { name: "+1-284" },
  { name: "+673" },
  { name: "+359" },
  { name: "+226" },
  { name: "+257" },

  { name: "+855" },
  { name: "+237" },
  { name: "+1" },
  { name: "+238" },
  { name: "+1-345" },
  { name: "+236" },
  { name: "+235" },
  { name: "+56" },
  { name: "+86" },
  { name: "+57" },
  { name: "+269" },
  { name: "+243" },
  { name: "+242" },
  { name: "+682" },
  { name: "+506" },
  { name: "+385" },
  { name: "+53" },
  { name: "+357" },
  { name: "+420" },

  { name: "+45" },
  { name: "+253" },
  { name: "+1-767" },
  { name: "+1-809" },

  { name: "+593" },
  { name: "+20" },
  { name: "+503" },
  { name: "+240" },
  { name: "+291" },
  { name: "+372" },
  { name: "+268" },
  { name: "+251" },

  { name: "+679" },
  { name: "+358" },
  { name: "+33" },

  { name: "+241" },
  { name: "+220" },
  { name: "+995" },
  { name: "+49" },
  { name: "+233" },
  { name: "+350" },
  { name: "+30" },
  { name: "+299" },
  { name: "+1-473" },
  { name: "+1-671" },
  { name: "+502" },
  { name: "+44" },
  { name: "+224" },
  { name: "+245" },
  { name: "+592" },

  { name: "+509" },
  { name: "+504" },
  { name: "+852" },
  { name: "+36" },

  { name: "+354" },
  { name: "+91" },
  { name: "+62" },
  { name: "+98" },
  { name: "+964" },
  { name: "+353" },
  { name: "+44" },
  { name: "+972" },
  { name: "+39" },

  { name: "+1-876" },
  { name: "+81" },
  { name: "+962" },

  { name: "+7" },
  { name: "+254" },
  { name: "+686" },
  { name: "+850" },
  { name: "+82" },
  { name: "+965" },
  { name: "+996" },

  { name: "+856" },
  { name: "+371" },
  { name: "+961" },
  { name: "+266" },
  { name: "+231" },
  { name: "+218" },
  { name: "+423" },
  { name: "+370" },
  { name: "+352" },

  { name: "+853" },
  { name: "+389" },
  { name: "+261" },
  { name: "+265" },
  { name: "+60" },
  { name: "+960" },
  { name: "+223" },
  { name: "+356" },
  { name: "+692" },
  { name: "+222" },
  { name: "+230" },
  { name: "+52" },
  { name: "+691" },
  { name: "+373" },
  { name: "+377" },
  { name: "+976" },
  { name: "+382" },
  { name: "+1-664" },
  { name: "+212" },
  { name: "+258" },
  { name: "+95" },

  { name: "+264" },
  { name: "+674" },
  { name: "+977" },
  { name: "+31" },
  { name: "+687" },
  { name: "+64" },
  { name: "+505" },
  { name: "+227" },
  { name: "+234" },
  { name: "+683" },
  { name: "+850" },
  { name: "+47" },

  { name: "+968" },

  { name: "+92" },
  { name: "+680" },
  { name: "+970" },
  { name: "+507" },
  { name: "+675" },
  { name: "+595" },
  { name: "+51" },
  { name: "+63" },
  { name: "+48" },
  { name: "+351" },
  { name: "+1-787" },

  { name: "+974" },

  { name: "+40" },
  { name: "+7" },
  { name: "+250" },

  { name: "+290" },
  { name: "+1-869" },
  { name: "+1-758" },
  { name: "+508" },
  { name: "+1-784" },
  { name: "+685" },
  { name: "+378" },
  { name: "+239" },
  { name: "+966" },
  { name: "+221" },
  { name: "+381" },
  { name: "+248" },
  { name: "+232" },
  { name: "+65" },
  { name: "+421" },
  { name: "+386" },
  { name: "+677" },
  { name: "+252" },
  { name: "+27" },
  { name: "+211" },
  { name: "+34" },
  { name: "+94" },
  { name: "+249" },
  { name: "+597" },
  { name: "+268" },
  { name: "+46" },

  { name: "+41" },
  { name: "+963" },

  { name: "+886" },
  { name: "+992" },
  { name: "+255" },
  { name: "+66" },
  { name: "+670" },
  { name: "+228" },
  { name: "+690" },
  { name: "+676" },
  { name: "+1-868" },
  { name: "+216" },
  { name: "+90" },
  { name: "+993" },

  { name: "+1-649" },
  { name: "+688" },

  { name: "+256" },
  { name: "+380" },
  { name: "+971" },
  { name: "+44" },
  { name: "+1" },
  { name: "+598" },
  { name: "+998" },

  { name: "+678" },
  { name: "+379" },
  { name: "+58" },
  { name: "+84" },

  { name: "+681" },
  { name: "+212" },
  { name: "+967" },
  { name: "+260" },
  { name: "+263" }
];

export const WORKerTypeList = [
	{name: 'All WORKers', value:'all'},
	// {name: 'Nucleus', value:'nucleus'},
	// {name: 'Core', value:'core'},
	// {name: 'Active', value:'active'},
	// {name: 'Compassionate', value:'compassionate'},
	// {name: 'Virtually Active', value:'virtuallyActive'},
	// {name: 'Inactive', value:'inActive'},
]

export const taskTypeList = [
	{name: 'Social Media', value: 'socialMedia'}
]

export const qualifications = [
  { value: "10th", label: "10th / Secondary" },
  { value: "12th", label: "12th / Higher Secondary" },
  { value: "diploma", label: "Diploma" },
  { value: "iti", label: "ITI" },
  { value: "bachelor", label: "Bachelor's Degree" },
  { value: "btech", label: "B.Tech / BE" },
  { value: "bsc", label: "B.Sc" },
  { value: "bcom", label: "B.Com" },
  { value: "ba", label: "BA" },
  { value: "master", label: "Master's Degree" },
  { value: "mtech", label: "M.Tech / ME" },
  { value: "msc", label: "M.Sc" },
  { value: "mba", label: "MBA" },
  { value: "phd", label: "PhD" },
  { value: "other", label: "Other" }
];

export const professions = [
  { value: "student", label: "Student" },
  { value: "homemaker", label: "Homemaker" },
  { value: "unemployed", label: "Unemployed" },

  // Corporate / Private
  { value: "software_engineer", label: "Software Engineer" },
  { value: "developer", label: "Developer" },
  { value: "data_scientist", label: "Data Scientist" },
  { value: "product_manager", label: "Product Manager" },
  { value: "designer", label: "Designer (UI/UX/Graphic)" },
  { value: "marketing", label: "Marketing Professional" },
  { value: "sales", label: "Sales Professional" },
  { value: "hr", label: "HR Professional" },
  { value: "finance", label: "Finance / Accounts" },
  { value: "customer_support", label: "Customer Support" },

  // Government / Public
  { value: "government_employee", label: "Government Employee" },
  { value: "defense", label: "Defense Personnel" },
  { value: "police", label: "Police / Law Enforcement" },

  // Business / Self-employed
  { value: "business_owner", label: "Business Owner" },
  { value: "self_employed", label: "Self Employed" },
  { value: "freelancer", label: "Freelancer" },

  // Education
  { value: "teacher", label: "Teacher" },
  { value: "professor", label: "Professor / Lecturer" },

  // Healthcare
  { value: "doctor", label: "Doctor" },
  { value: "nurse", label: "Nurse" },
  { value: "pharmacist", label: "Pharmacist" },
  { value: "healthcare_worker", label: "Healthcare Worker" },

  // Legal
  { value: "lawyer", label: "Lawyer / Advocate" },
  { value: "chartered_accountant", label: "Chartered Accountant" },

  // Skilled / Technical
  { value: "electrician", label: "Electrician" },
  { value: "mechanic", label: "Mechanic" },
  { value: "plumber", label: "Plumber" },
  { value: "technician", label: "Technician" },

  // Agriculture
  { value: "farmer", label: "Farmer" },
  { value: "agriculture_worker", label: "Agriculture Worker" },

  // Transport
  { value: "driver", label: "Driver" },
  { value: "delivery", label: "Delivery Personnel" },

  // Others
  { value: "artist", label: "Artist" },
  { value: "content_creator", label: "Content Creator" },
  { value: "retired", label: "Retired" },
  { value: "other", label: "Other" }
];